<template>
  <div class="deductions">
    <div class="header">DRIVER DEDUCTIONS</div>
    <div class="deductions-container">
      <div class="deduction-content">
        <deduction-list :isMobile="isMobile"></deduction-list>
      </div>
    </div>
    <deduction-form></deduction-form>
    <deduction-delete></deduction-delete>
  </div>
</template>

<script>
import DeductionDelete from './DeductionDelete'
import DeductionForm from './DeductionForm'
import DeductionList from './DeductionList'
export default {
  name: 'driver-deductions',
  components: { DeductionDelete, DeductionForm, DeductionList },
  data() {
    return {
      isMobile: false
    }
  },
  mounted() {
    let self = this
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      self.isMobile = true
    } else {
      self.isMobile = false
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  font-weight: 700;
  font-size: 22px;
  color: #3F2975;
  background-color: #fff;
  display: block;
  line-height: 22px;
  padding: 14px 0 14px 64px;
  border-bottom: 1px solid rgba(0,0,0,0.15);
  z-index: 2;
}
.deductions { position: relative; }
.deductions-container {
  position: fixed;
  top: 51px;
  left: 0;
  width: 100%;
  height: 100%;
}
.deduction-content {
  position: absolute;
  top: 0;
  left: 0;
  height: calc(100% - 51px);
  width: 100%;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/ProviderDeductions/index.vue